import cn from "classnames";
import { bem } from "@react-md/utils";
var block = bem("rmd-button");
/**
 * Creates a button theme based on the button theming props. This is really just
 * used so that other elements like clickable `<div>`s or `<input type="file">`
 * can look like buttons.
 *
 * @param props An object containing the themeable button props to generate a
 * button theme className.
 * @return a string of class names to create an element with a button theme.
 */
export default function buttonThemeClassNames(props) {
    var _a;
    var _b = props.theme, theme = _b === void 0 ? "clear" : _b, _c = props.themeType, themeType = _c === void 0 ? "flat" : _c, _d = props.buttonType, buttonType = _d === void 0 ? "text" : _d, disabled = props.disabled, className = props.className;
    var text = buttonType === "text";
    var icon = buttonType === "icon";
    var outline = themeType === "outline";
    var contained = themeType === "contained";
    var clear = theme === "clear";
    return cn(block((_a = {
            text: text,
            icon: icon,
            disabled: disabled,
            contained: !disabled && contained,
            outline: outline
        },
        _a[theme] = !disabled && !clear && contained,
        _a["text-" + theme] = !disabled && !clear && !contained,
        _a["outline-" + theme] = !disabled && !clear && outline,
        _a)), className);
}
//# sourceMappingURL=buttonThemeClassNames.js.map